<template>
  <div>
    <nav aria-label="Page navigation example">
      <ul class="pagination flex-wrap justify-content-center">
        <li
          v-for="pageCounter in numberOfPages"
          class="page-item"
          :class="{ active: pageCounter === currentPage }"
          :key="pageCounter"
          @click="$emit('changePage', pageCounter)"
        >
          <div class="page-link">{{ pageCounter }}</div>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: ['items', 'currentPage', 'pageSize'],
  watch: {
    numberOfPages: {
      handler: function() {
        if (this.currentPage > this.numberOfPages) {
          this.$emit('changePage', Math.max(1, this.numberOfPages));
        }
      },
      deep: true,
    },
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.items.length / this.pageSize);
    },
  },
  methods: {
    changePage(page) {
      this.currentPage = page;
    },
  },
};
</script>

<style scoped></style>
